import get from 'lodash/get';

const styles = ({ color, fontSize, margin, padding, theme }) => ({
  headerContainer: {
    padding: `0 ${get(padding, 'p36')}`,
  },
  topContainer: {
    display: 'flex',
  },
  deleteContainer: {
    marginLeft: 'auto',
    marginTop: '30px',
    marginRight: '30px',
  },
  noMargin: {
    marginTop: '0 !important',
  },
  pageTitle: {
    margin: `${get(margin, 'm5')} 0`,
    wordWrap: 'break-word',
  },
  subTitle: {
    paddingBottom: `${get(padding, 'p10')}`,
    fontSize: `${get(fontSize, 'bodyText')}`,
    wordWrap: 'break-word',
  },
  statusContainer: {
    display: 'flex',
  },
  statusBar: {
    margin: `${get(margin, 'm5')} 0 ${get(margin, 'm21')} 0`,
    '& span': {
      position: 'relative',
      display: 'inline-block',
      marginBottom: '5px',
      paddingLeft: '15px',
      verticalAlign: 'middle',
      fontSize: get(fontSize, 'bodyText'),
      letterSpacing: 0,
    },
  },
  status: {
    fontSize: `${get(fontSize, 'bodyText')} !important`,
    '&:before': {
      display: 'inline-block',
      position: 'absolute',
      content: '""',
      left: 0,
      top: '50%',
      marginTop: '-6px',
      height: '10px',
      width: '10px',
      borderRadius: '10px',
    },
  },
  available: {
    color: get(color, 'success'),
    '&:before': {
      backgroundColor: get(color, 'success'),
    },
  },
  pending: {
    '&:before': {
      backgroundColor: get(color, 'pending'),
    },
  },
  unavailable: {
    '&:before': {
      backgroundColor: get(color, 'disabledBackground'),
    },
  },
  noStatus: {
    '&:before': {
      backgroundColor: get(color, 'disabledBackground'),
    },
  },
  pendingEnrollment: {
    color: get(color, 'disabledGraphic'),
    '&:before': {
      backgroundColor: get(color, 'disabledGraphic'),
    },
  },
  cancelIcon: {
    marginLeft: 3,
    '&:focus': {
      outlineWidth: '1px !important',
      outlineOffset: '-4px !important',
      outlineStyle: 'solid !important',
      outlineRadius: '3px !important',
    },
  },
  errorBackgroundButton: {
    backgroundColor: get(color, 'error'),
    color: get(color, 'bodyBackground'),
    '&:hover': {
      backgroundColor: get(color, 'borderColor'),
    },
    '&:focus': {
      backgroundColor: get(color, 'borderColor'),
    },
  },
  cancelButton: {
    textTransform: 'none',
    color: get(theme, 'color.primaryButtonBackground'),
    backgroundColor: get(theme, 'color.primaryButtonText'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
    padding: 5,
    marginLeft: 10,
    '&:focus': {
      outlineWidth: '1px !important',
      outlineOffset: '-4px !important',
      outlineStyle: 'solid !important',
      outlineRadius: '3px !important',
    },
    '& span': {
      paddingLeft: 0,
    },
  },
  resendButton: {
    marginRight: 15,
    height: 40,
  },
});

export default styles;
